"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const capitaliseFirstLetterOfString_1 = __importDefault(require("./capitaliseFirstLetterOfString"));
exports.default = (string) => {
    const explode = string.split(' ');
    for (let i = 0; i < explode.length; i++) {
        explode[i] = (0, capitaliseFirstLetterOfString_1.default)(explode[i]);
    }
    return explode.join(' ');
};
